import { SimpleLayout } from '@/components/Layout';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const PasswordResetLayout = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { t } = useTranslation();

  return (
    <SimpleLayout>
      <div className="flex h-full items-center justify-center p-3 pt-10">
        <div className="flex w-full max-w-xl flex-col gap-5 rounded-3xl bg-white p-6 drop-shadow lg:w-1/2 lg:max-w-4xl lg:p-12">
          <h2 className="text-xl font-semibold lg:text-2xl">
            {t('パスワード設定')}
          </h2>
          {children}
        </div>
      </div>
    </SimpleLayout>
  );
};
